import { createFileRoute } from '@tanstack/react-router';

import { getLocalizedTitle } from '../title';

export const Route = createFileRoute('/_app/users/')({
  head: () => ({
    meta: [{ title: getLocalizedTitle('user_management.page_title', 'User management') }],
  }),
});
